const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrafficAnalyzer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M54 493v2H30v-2a5.977 5.977 0 0 1 2.894-5.11 4.984 4.984 0 0 1 4.143-8.779c.016.633.039 1.353.072 2.106a3 3 0 1 0 .557 5.277A.605.605 0 0 0 38 487s-.807.008-1.4 2.061A4.007 4.007 0 0 0 36 489a4 4 0 0 0-4 4h4.053c-.031.609-.053 1.26-.053 2h2v-2c0-2.313 1.7-4.8 4.264-6.1a7 7 0 1 1 7.473 0C52.3 488.2 54 490.687 54 493Zm-3-12a5 5 0 1 0-5 5 5 5 0 0 0 5-5Zm-5 7c-3.372 0-6 2.791-6 5h12c0-2.209-2.628-5-6-5Z",
    transform: "translate(-30 -474)",
    style: {
      fill: "#f16334",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficAnalyzer);
export default __webpack_public_path__ + "static/media/trafficAnalyzer.a350529cb83c49d9c1392224aa62a35d.svg";
export { ForwardRef as ReactComponent };